export const environment = {
  production: true,
  hmr: false,
  envName: (window as any)['env']['envName'] || 'acceptance',
  envBaseUrl: (window as any)['env']['envBaseUrl'] || 'https://acceptance.beachyapp.com/api',
  firebaseConfig: {
    apiKey: (window as any)['env']['firebaseConfig']['apiKey'] || 'AIzaSyBN1DF6xDVablL--_Ahqq6rzDCLlLobN1M',
    authDomain: (window as any)['env']['firebaseConfig']['authDomain'] || 'obe-acceptance.firebaseapp.com',
    databaseURL: (window as any)['env']['firebaseConfig']['databaseURL'] || 'https://obe-acceptance.firebaseio.com',
    projectId: (window as any)['env']['firebaseConfig']['projectId'] || 'obe-acceptance',
    storageBucket: (window as any)['env']['firebaseConfig']['storageBucket'] || 'obe-acceptance.appspot.com',
    messagingSenderId: (window as any)['env']['firebaseConfig']['messagingSenderId'] || '153128036674',
    appId: (window as any)['env']['firebaseConfig']['appId'] || '1:153128036674:web:57ba8195d355d301dc80db',
    measurementId: (window as any)['env']['firebaseConfig']['measurementId'] || 'G-V1YEY0FJRC'
  },
  orderTimeoutInMinutes: {
    warning: (window as any)['env']?.['orderTimeoutInMinutes']?.['warning'] ?? 4,
    error: (window as any)['env']?.['orderTimeoutInMinutes']?.['error'] ?? 5,
  },
  stripeKey: (window as any)['env']?.['stripeKey'] ?? 'pk_test_u6EwgR7lHu8YKOqO5AOynNVj',
  storefrontFallbackToOwner: true,
  qaPerPrEnabled: true,
};
